import { useGetTaxInformationApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";

export function usePayoutTaxInfo() {
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: {
        item: { taxInfo },
      },
    },
  } = useGetTaxInformationApiV1Suspense(workspaceId);

  return {
    taxInfo,
  };
}
